module.exports = __webpack_public_path__ + "static/media/developerActivity.3e23ca14.svg";